module.exports = __webpack_public_path__ + "static/media/balloon1.2c6ec35d.png";